import * as Yup from 'yup'
import { businessNameValidation, callToActionValidation } from '../../../../validations'
import { BUSINESS_NAME } from '../../../../fields'
import { CALL_TO_ACTION } from '../../../../../../ReusableFormFields/CallToActionFields/fields'

export const validationSchema = Yup.object({
  [BUSINESS_NAME]: businessNameValidation,
  [CALL_TO_ACTION]: callToActionValidation
})
